var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeachIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.78378 9.16259C9.58628 8.34365 10.0811 7.22205 10.0811 5.98488C10.0811 3.47721 8.04821 1.44434 5.54054 1.44434C3.03287 1.44434 1 3.47721 1 5.98488C1 8.49255 3.03287 10.5254 5.54054 10.5254C6.81104 10.5254 7.95966 10.0036 8.78378 9.16259ZM8.78378 9.16259L13 13.4443",
    stroke: "#02A0FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeachIconB);
export default __webpack_public_path__ + "static/media/SeachIconB.55b11a382499946eb53064f38a02b454.svg";
export { ForwardRef as ReactComponent };